module.exports = __webpack_public_path__ + "static/media/logo_slack.95e69a6c.svg";